export default {
  role: 'Role',
  roles: 'Roles',
  verbose_role: 'un rôle',
  modules: 'Modules',
  general_info: 'Informations générales',
  userrights_listing: 'Permissions'
};
